module.exports = __webpack_public_path__ + "img/cover3.6bc1986a.png";